/* eslint-disable max-len */
import React from 'react';
import ThreeDotsLoader from '../../../Components/LoadingDots';

function DistributorAppAccessModal({
    showModal, setShowModal, enable, handleConfirm, submitted,
}) {
    if (!showModal) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(0,0,0,0.5)]" role="dialog" aria-modal="true" aria-labelledby="distributorAppAccessLabel">
            <div className="flex flex-col gap-5 w-[440px] max-w-[calc(100%-32px)] bg-white rounded-xl shadow-[0px_4px_24px_0px_rgba(0,0,0,0.15)] px-8 py-7">
                <h5 className="text-xl font-bold text-[#090406]" id="distributorAppAccessLabel">
                    Confirm Action
                </h5>
                <div className="text-sm leading-[22px] text-[#66666B]">
                    <p>
                        {`Are you sure you want to ${enable ? 'enable' : 'disable'} the Distributor Application?`}
                    </p>
                    <p>
                        {enable
                            ? 'This will restore access for all distributors to the application.'
                            : 'This will prevent all distributors from accessing the application.'}
                    </p>
                </div>
                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        className="border border-[#555259] bg-[#FFFFFF] text-base font-normal text-[#555259] w-[158px] h-[47px] rounded-lg"
                        disabled={submitted}
                        onClick={() => setShowModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="bg-[#555259] flex justify-center items-center text-[15px] font-normal text-[#ffffff] w-[158px] h-[47px] rounded-lg"
                        disabled={submitted}
                        onClick={() => handleConfirm()}
                    >
                        {submitted ? <ThreeDotsLoader /> : `Yes, ${enable ? 'Enable' : 'Disable'}`}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DistributorAppAccessModal;
